/**
 * Learn more about deep linking with React Navigation
 * https://reactnavigation.org/docs/deep-linking
 * https://reactnavigation.org/docs/configuring-links
 */

import { LinkingOptions } from '@react-navigation/native';
import * as Linking from 'expo-linking';

import { RootStackParamList } from '../types';
// import useRegisterDeferredLinks, { registerAppsFlyer } from '../hooks/useRegisterDeferredLinks';
import { getInitialLink, isAvailable, subscribeToDeepLink } from '../hooks/useRegisterFirebaseDeepLinks';


// Configuración de las URL
// https://reactnavigation.org/docs/deep-linking/
// Nombres de ruta de react Navigation https://reactnavigation.org/docs/configuring-links


const linking: LinkingOptions<RootStackParamList> = {
  prefixes: [Linking.createURL('/'), "https://app.ding-dong.mx"],
  config: {
    screens: {
      Root: {
        screens: {
          TabOne: {
            screens: {
              TabOneScreen: 'one',
            },
          },
          TabTwo: {
            screens: {
              TabTwoScreen: 'two',
            },
          },
        },
      },
      Modal: 'modal',
      NotFound: '*',

      "Invitation.Index": 'i/:invitationId',
      "EntryPass.Detail": 'p/:passId',
      "ToS.Privacy": 'privacidad',
      "Support.Index": 'soporte',


      "Dashboards.EntryLogs": 'dashboards/entry-logs',

      "Auth.Login": "auth/login",

      "Main.Stack": {
        screens:{
          "Home": {
            screens: {
              "Main.Resident.Dashboard": "mi-vivienda",
              "Main.Resident.Access": "accesos",
              "Main.Settings.Index": '/mi-perfil',
            }
          },
          "Guard.Home": {
            screens: {
              "Guard.Access": "vigilancia/acceso",
              "Guard.Today": "vigilancia/hoy",
              "Guard.Log": "vigilancia/bitacora",
              "Guard.Tickets": "vigilancia/incidencias",
              "Guard.Settings": "vigilancia/mi-perfil",
            }
          },
          "Guard.Tickets.Detail": "vigilancia/incidencias/:ticketUuid",
        }
      },

      "MetaAdmin.Stack": {
        screens: {
          "MetaAdmin.Home": {
            screens: {
              "MetaAdmin.Dashboard": "meta",
              "MetaAdmin.Users.Index": "meta/usuarios",
              "MetaAdmin.Communities.Index": "meta/fraccionamientos",
              "MetaAdmin.Devices.Index": "meta/dispositivos",
            },
          },
          "MetaAdmin.Users.Detail": "meta/usuarios/:uuid",
          "MetaAdmin.Communities.Detail": "meta/fraccionamientos/:uuid",
        },
      },
    },
  },


  // Custom function to get the URL which was used to open the app
  async getInitialURL() {
    //! DEPRECATEDISIMO
    // const firebaseDeepLinkAvailable = isAvailable()

    // if (firebaseDeepLinkAvailable){
    //   const deepLinkUrl = await getInitialLink()

    //   if(deepLinkUrl){
    //   return deepLinkUrl;
    //   }
    // }


    // As a fallback, you may want to do the default deep link handling
    const url = await Linking.getInitialURL();

    return url;
  },

  // Sin async: NavigationContainer usa lo que regresa como cleanup de un useEffect, y con
  // async regresaba una Promise ("useEffect must not return anything besides a function"
  // y luego "Object is not a function" al desmontar). Si algún día hace falta await
  // (ej. Firebase), hacerlo adentro sin volver async la función.
  subscribe(listener) {
    // const unsubscribeAppsFlyer = registerAppsFlyer((data) => {
    //   console.log("Linking - flyer received >>>>>>", JSON.stringify(data, null, 2))

    //   if (data.deep_link_value == 'register_token'){
    //     const registerToken = data.deep_link_sub1
    //     // const url = `/register/token?token=${registerToken}`
    //     const url = `/i/${registerToken}`

    //     listener(Linking.createURL(url))
    //   }
    // })

    // Listen to incoming links from deep linking
    const linkingSubscription = Linking.addEventListener('url', ({ url }) => {
      const parsedUrl = Linking.parse(url);
      const { hostname, path, queryParams } = parsedUrl

      console.log(`Linking - Linked to app with hostname: ${hostname}, path: ${path} and data: ${JSON.stringify(queryParams)}`);
      
      listener(url);
    });


    // Listen to incoming links from Firebase Dynamic Links
    // const unsubscribeFirebase = dynamicLinks().onLink((link) => {
    //   console.log("[DYNAMICLINK] received", JSON.stringify(link))
    //   listener(link.url);
    // });
    // const unsubscribeToFirebaseDyamicLinks = await subscribeToDeepLink(listener)


    return () => {
      // Clean up the event listeners
      // unsubscribeAppsFlyer()
      linkingSubscription.remove();

      // if (unsubscribeToFirebaseDyamicLinks) {
      //   unsubscribeToFirebaseDyamicLinks();
      // }
    };
  },
};

export default linking;
